import { parsedContentSchema } from "@/pages/Admin/AI/Ai";
import axios from "axios";
import { z } from "zod";

export interface iAiConfig {
  prompt: string;
}

export async function runAiJob() {
  const response = await axios.post("/ai/run-ai-job");
  return response.data;
}

export async function getAiConfig() {
  const response = await axios.get("/ai");
  return response.data;
}

export async function askGpt(prompt: any) {
  const response = await axios.post("/ai/ask", { prompt });
  return response.data;
}

export async function editAiConfig(prompt: any) {
  const response = await axios.post("/ai", { prompt });
  return response.data;
}

export async function getMonitoring(payload: {
  startDate?: Date;
  endDate?: Date;
}) {
  const response = await axios.get("/ai/monitoring", {
    params: payload,
  });
  return response.data;
}

export const bookingEmailLabels = ["inbox", "archived"];

export type bookingEmailLabel = (typeof bookingEmailLabels)[number];

export async function getPaginated(payload: {
  page?: number;
  size?: number;
  startDate?: Date;
  endDate?: Date;
  errorTypes?: string[];
  labels?: bookingEmailLabel[];
}) {
  const response = await axios.get("/ai/paginate", {
    params: payload,
  });
  return response.data;
}

export async function getEmail(id: string) {
  const response = await axios.get(`/ai/${id}`);
  return response.data;
}

export async function repairNft(payload: {
  emailId: string;
  nft: z.infer<typeof parsedContentSchema>;
}) {
  const response = await axios.post("/ai/repairNft", payload);
  return response.data;
}

export async function archiveEmail(id: string) {
  const response = await axios.post(`/ai/setlabels/${id}`, {
    labels: ["archived"],
  });
  return response.data;
}

export async function batchArchiveEmails(ids: string[]) {
  const response = await axios.post(`/ai/batch/setlabels`, {
    ids,
    labels: ["archived"],
  });
  return response.data;
}

export async function unarchiveEmail(id: string) {
  const response = await axios.post(`/ai/setlabels/${id}`, {
    labels: ["inbox"],
  });
  return response.data;
}

export async function batchUnarchiveEmails(ids: string[]) {
  const response = await axios.post(`/ai/batch/setlabels`, {
    ids,
    labels: ["inbox"],
  });
  return response.data;
}

export async function getArchivedEmailIdsInDateRange(payload: {
  startDate?: Date;
  endDate?: Date;
}) {
  const countResponse = await getPaginated({
    ...payload,
    page: 1,
    size: 1,
    labels: ["archived"],
  });

  const total = countResponse.total ?? 0;

  if (total === 0) {
    return [];
  }

  const response = await getPaginated({
    ...payload,
    page: 1,
    size: total,
    labels: ["archived"],
  });

  return response.data.map((email: { _id: string }) => email._id);
}

export async function retryAiJob(payload: { emailId: string }) {
  const response = await axios.post("/ai/retryAiJob", payload);
  return response.data;
}
